module.exports = __webpack_public_path__ + "static/media/logo_FE.975dadbb.svg";